import { ISetCompleteVehicleSelectedAction } from "../interfaces/garage.interface";

export function setCompleteVehicleSelected(data: boolean): ISetCompleteVehicleSelectedAction {
  return {
    type: "SET_COMPLETE_VEHICLE_SELECTED",
    data,
  };
}
